import React, { useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import ProfileCompletionStatus from "components/common/ProfileCompletionStatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaymentInfo from "./PaymentInfo";
import SecuritySettings from "./SecuritySettings";
import { useAuth } from "contexts/AuthContext";
import coverSrc from "assets/img/generic/4.jpg";
import AvatarUpload from "./AvatarUpload";
import FieldSection from "./FieldSection";
import UserAddresses from "./UserAddresses";
import UserPersonalInfo from "./UserPersonalInfo";

const Profile = () => {
  const { user } = useAuth();
  const coverImageSrc = user.coverImage || coverSrc;


  return (
    <>
      <Row className="mt-1 g-3">
        <Col lg={4} className="order-2 order-lg-2">
          <div className="sticky-profile-status">
            <ProfileCompletionStatus />
          </div>
        </Col>
        <Col lg={8} className="order-1 order-lg-1">
          <Tabs
            defaultActiveKey="profile"
            id="uncontrolled-tab-example"
            color="success"
            className="custom-tabs bg-light border"
          >
            <Tab
              eventKey="profile"
              title={
                <>
                  <FontAwesomeIcon icon="user" className="me-2" />
                  Personal Information
                </>
              }
              className="py-3 px-3"
            >
              <UserPersonalInfo user={user} />
            </Tab>

            <Tab
              eventKey="addresses"
              title={
                <>
                  <FontAwesomeIcon icon="map-marker-alt" className="me-2" />
                  Addresses
                </>
              }
              className="py-3"
            >
              <UserAddresses />
            </Tab>

            <Tab
              eventKey="security"
              title={
                <>
                  <FontAwesomeIcon icon="lock" className="me-2" />
                  Security Settings
                </>
              }
              className="py-3"
            >
              <SecuritySettings />
            </Tab>

            <Tab
              eventKey="payment"
              title={
                <>
                  <FontAwesomeIcon icon="credit-card" className="me-2" />
                  Payment Info
                </>
              }
              className="py-3"
            >
              <PaymentInfo userId={user.id} />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default Profile;
